"use client";
import { Swiper, SwiperSlide } from "swiper/react";
import { useState } from "react";
import { Swiper as SwiperType } from "swiper";
import { reviveSwiperOnResize } from "@/app/utils/swiperResize";
import SwiperButton from "../buttons/SwiperButton";
import CategoryCard from "../cards/categoryCard/CategoryCard";
import { SectionItem } from "@/app/lib/features/home/home.types";

interface CategoriesSwiperProps {
  categories?: SectionItem[];
}

const CategoriesSwiper = ({ categories }: CategoriesSwiperProps) => {
  const [showLeftGradient, setShowLeftGradient] = useState(false);
  const [showRightGradient, setShowRightGradient] = useState(true);

  const updateGradients = (swiper: SwiperType): void => {
    setShowLeftGradient(!swiper.isBeginning);
    setShowRightGradient(!swiper.isEnd);
  };

  if (!categories || categories.length === 0) {
    return null;
  }

  return (
    <Swiper
      className="relative"
      spaceBetween={10}
      slidesPerView={2}
      onSwiper={updateGradients}
      onSlideChange={updateGradients}
      watchSlidesProgress={false}
      updateOnWindowResize={false}
      // content-visibility ile ertelenen section'larda 0 genişlikte init olan
      // Swiper'ı kurtarır — bkz. swiperResize.ts
      onResize={reviveSwiperOnResize}
      breakpoints={{
        375: {
          slidesPerView: 2.2,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 2.5,
          spaceBetween: 12,
        },
        640: {
          slidesPerView: 2.8,
          spaceBetween: 12,
        },
        768: {
          slidesPerView: 3.2,
          spaceBetween: 14,
        },
        900: {
          slidesPerView: 3.5,
          spaceBetween: 14,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 16,
        },
      }}
    >
      {categories.map((category, i) => (
        <SwiperSlide key={category.id || i}>
          <CategoryCard category={category} />
        </SwiperSlide>
      ))}
      <div className="absolute z-50 top-1/2 -translate-y-1/2 left-0 w-full items-center justify-between px-3 pointer-events-none hidden xl:flex">
        <SwiperButton position="left" slideMode="group" />
        <SwiperButton position="right" slideMode="group" />
      </div>
      <div
        className={`absolute top-0 left-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-r from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showLeftGradient ? "opacity-100" : "opacity-0"
        }`}
      />
      <div
        className={`absolute top-0 right-0 z-20 w-5 sm:w-8 lg:w-13.75 h-full bg-linear-to-l from-white to-transparent transition-opacity duration-300 pointer-events-none hidden xl:block ${
          showRightGradient ? "opacity-100" : "opacity-0"
        }`}
      />
    </Swiper>
  );
};

export default CategoriesSwiper;
